"use client";
import React, { useEffect } from "react";
import LoginContainer from "./components/login-container";
import { useSearchParams } from "next/navigation";
import LoadingIcon from "@/app/assets/icons/loading";
import GoogleRecaptcha from "../hooks/google-recaptcha";

// Configure reCAPTCHA globally
const RECAPTCHA_CONFIG = {
  enabled: process.env.APP_RECAPTCHA_ENABLED === 'true', // Control via env variable
  siteKey: process.env.APP_RECAPTCHA_KEY || ""
};

const Page = () => {
  return (
    <React.Suspense fallback={<LoadingIcon className="animate-spin" />}>
      <Content />
    </React.Suspense>
  );
};

const Content = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const hideRecaptchaBadge = () => {
      const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
      if (badge) {
        badge.style.visibility = 'hidden';
      }      
    };
  
    // Give it some time in case reCAPTCHA is not loaded instantly
    const interval = setInterval(() => {
      hideRecaptchaBadge();
    }, 0);
  
    // Clear interval once badge is found and hidden
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000); // Stops trying after 5 seconds
  
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);
  
  
  // Pass reCAPTCHA configuration to LoginContainer regardless of whether reCAPTCHA is enabled
  return (
    <>
      {RECAPTCHA_CONFIG.enabled ? (
        <GoogleRecaptcha sitekey={RECAPTCHA_CONFIG.siteKey}>
          <div className="mt-22 flex min-h-[calc(100vh-68px)] w-full justify-center md:h-auto md:min-h-0 md:justify-start">
            <LoginContainer 
              searchParams={searchParams} 
              recaptchaEnabled={RECAPTCHA_CONFIG.enabled} 
            />
          </div>
        </GoogleRecaptcha>
      ) : (
        <div className="mt-22 flex min-h-[calc(100vh-68px)] w-full justify-center md:h-auto md:min-h-0 md:justify-start">
          <LoginContainer 
            searchParams={searchParams} 
            recaptchaEnabled={RECAPTCHA_CONFIG.enabled} 
          />
        </div>
      )}
    </>
  );
};

export default Page;